import router from '@/router';
import { DataLayerService } from '@/services/DataLayerService';
import { AnalyticsService } from '@/services/AnalyticsService';
import { AdjustService } from '@/services/AdjustService';
import { UrlHelper } from '@/helpers/UrlHelper';
import { SET_STEP } from '@/constants/mutation-types';
import store from '@/store';
import AjaxService from '@/services/AjaxService';

/**
 * Handles page navigation
 */
export class NavigationService {
    private readonly dataLayerService: DataLayerService;
    private readonly analyticsService: AnalyticsService;
    private readonly adjustService: AdjustService;
    private readonly ajaxService: AjaxService;
    private readonly commit: CallableFunction;
    private store: typeof store;

    constructor(
        dataLayerService: DataLayerService,
        analyticsService: AnalyticsService,
        adjustService: AdjustService,
        ajaxService: AjaxService,
        commit: CallableFunction,
        dataStore: typeof store
    ) {
        this.dataLayerService = dataLayerService;
        this.analyticsService = analyticsService;
        this.adjustService = adjustService;
        this.ajaxService = ajaxService;
        this.commit = commit;
        this.store = dataStore;
        this.checkToken().then(() => '');
    }

    /**
     * Changes page to one passed in name.
     * @param name Target route name. Must be registered as route name in vue router
     */
    public async goToRoute(name: string) {
        // if next was passed as goToClientZone - statement will redirect to the TMS client zone
        // this feature was created because there is exists problem with the old costumers
        if (name === 'goToClientZone') {
            setTimeout(() => {
                (window.location as any) = UrlHelper.getHubUrl();
            }, 2000);
        }

        let analyticsName = name;

        /*
         * Set suffix for analytics for the mobile routes
         * Note, that this suffix will not be set if you start on mobile, only if choose to go mobile and enter the page via link received in SMS
         **/
        if (store.state.isMobile) {
            analyticsName += '_M';
        }

        try {
            this.dataLayerService.push(analyticsName);
            const currentQuery = router.currentRoute.value.query;
            const shouldPreserveHybridContext =
                (currentQuery.mobile === 'true' ||
                    currentQuery.qrCode === 'true') &&
                [
                    'mobileDocumentChoice',
                    'mobileDocumentUpload',
                    'mobileReturnToDesktop',
                    'uploadException',
                ].includes(name);

            await router.push(
                shouldPreserveHybridContext
                    ? {
                          name,
                          query: currentQuery,
                      }
                    : { name }
            );
            this.adjustService.push(name);
            this.commit(SET_STEP, name);
        } catch (e) {
            console.error(e);
        }
    }

    public async checkToken() {
        const splitPathName = window.location.pathname.split('/');
        if (Array.isArray(splitPathName) && splitPathName.length) {
            const currentRoutePath =
                '/' + splitPathName[splitPathName.length - 1];

            const list = ['/', '/login'];
            if (
                !list.includes(currentRoutePath) &&
                !this.ajaxService.getToken()
            ) {
                await this.goToRoute('restart');
            }
        }
    }
}
